import React, { type PropsWithChildren, useCallback } from 'react';

import { ErrorBoundary as CommonErrorBoundary } from '@atlassian/search-common/error-boundary';

import { logger, type LogProps } from '../../utils/logger';

type ErrorBoundaryProps = {
	fallback?: React.ReactNode;
	feature?: LogProps['feature'];
	element?: LogProps['element'];
};

export const ErrorBoundary = ({
	feature = 'sain-text-answer',
	element = 'container',
	...props
}: PropsWithChildren<ErrorBoundaryProps>): React.JSX.Element => {
	const onException = useCallback(
		async (error: Error) => {
			void logger.error({
				feature,
				element,
				operation: 'render',
				category: 'render',
				error,
				functionName: 'useLogException',
			});
		},
		[feature, element],
	);

	return (
		<CommonErrorBoundary {...props} onException={onException}>
			{props.children}
		</CommonErrorBoundary>
	);
};
